import { Button, Icon } from 'hakobio-react-ui';
import React from 'react';

const ErrorFallback = (props) => {
  return (
    <div
      className="h-100 w-100 f-col f-center gap-3 p-5 text-center anthracite"
      style={{
        color: 'var(--anthracite)'
      }}>
      <Icon name="setting-wrenches" size="5rem" className="py-3" />
      <div>
        <h1 style={{ fontSize: 24 }}>Something went wrong</h1>
        <p>
          An unexpected error has occurred. Please try again or contact support if the issue
          persists.
        </p>
      </div>
      <Button onClick={() => window.location.assign(window.location.pathname)}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
          <Icon name="rotate" />
          <div>Reload</div>
        </div>
      </Button>
    </div>
  );
};

export default ErrorFallback;
